import React, { FC } from 'react';
import { Control } from 'react-hook-form';

import { RoundingSettingField } from '../../../../components/rounding-setting-field';
import { FormSchema } from '../event-form.validation';

const ROUNDING_SETTING_FIELD = 'stepOne.eventDetails.fundraising-round.roundingSetting';

export type FundraisingRoundingSettingFieldProps = {
  control: Control<FormSchema>;
  disabled?: boolean;
};

export const FundraisingRoundingSettingField: FC<FundraisingRoundingSettingFieldProps> = ({
  control,
  disabled,
}) => <RoundingSettingField control={control} disabled={disabled} name={ROUNDING_SETTING_FIELD} />;
